const CardLoader = () => {
    return (
        <div className="card-loader">
            <div className="image-placeholder"></div>
            <div className="content-placeholder">
                <div className="line line-short"></div>
                <div className="line line-medium"></div>
                <div className="line line-long"></div>
            </div>
        </div>
    );
};

export default CardLoader;